<template>
  <div class="scroll_wrap">
    <div class="en_tit">{{party.info.en}}</div>
    <div class="scroll_tit">{{party.info.title}}</div>
    <div class="card_content gktp pc_container">
      <div class="center-box">
        <!-- <div class="card first">
          <div class="card_tit">学习贯彻党的二十届三中全会精神</div>
          <div class="card_btn">查看详情</div>
        </div> -->
        <div class="card" v-for="(item, index) in party.list" :key="index" >
           <el-image :src="icons[1]"  lazy />
            <div class="card_info" @click="$router.push({path:'/news/detail',query:{id:item.id, type:item.category.slug}})">
              <div class="card_tit">{{item.title}}</div>
              <div class="card_btn">查看详情</div>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    party :{
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      icons : {
        0 : require('@/assets/images/party/0.png'),
        1 : require('@/assets/images/party/1.png'),
        2 : require('@/assets/images/party/2.png')
      },
      currentIndex: null,
    }
  },
  methods: {
    
  },
}
</script>

<style lang="scss" scoped>
.scroll_wrap {
  width: 100%;
  padding-top: 30px;
  padding-bottom: 30px;
  text-align: center;
  background: #fff;

  .en_tit {
    font-family: SourceHanSansCN-Bold;
    font-size: 48px;
    color: #DCDCDC;
    text-transform: uppercase;
  }

  .scroll_tit {
    font-family: SourceHanSansCN-Bold;
    font-size: 36px;
    color: #000;
    margin-top: -15px;
    position: relative;
    &::after {
      content: '';
      display: block;
      background: #000;
      margin: 0 auto;
      width: 60px;
      height: 5px;
      background: #006DE8;
      margin-top: 13px;
    }
  }

  .gktp {
    margin-top:30px;
    .center-box {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .card {
        width: 32%;
        height: 255px;
        position: relative;
        &:hover {
          cursor: pointer;
          .card_info {
            background: red;
            .card_btn {
              display: block;
            }
          }
        }
        .card_info{
          height: 100%;
          width: 100%;
          position: absolute;
          top: 0;
          left: 0;
          display: flex;
          justify-content: center;
          flex-wrap: wrap;
          align-items: center;
          padding: 20px;
          .card_tit{
            max-height: 90px;
            line-height: 30px;
            color: #fff;
            font-size: 18px;
            text-align: left;
            display: flex;
            align-items: center;
            overflow: hidden;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3;
          }
          .card_btn{
            position: absolute;
            bottom: 10px;
            border: 1px solid #fff;
            color: #fff;
            width: 120px;
            height: 30px;
            line-height: 30px;
            text-align: center;
            border-radius: 20px;
            display: none;
          }
        }
        .el-image {
          vertical-align: top;
        }
      }
      .first{
        background: #F00;
        color: #fff;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .card_tit{
          font-family: Microsoft YaHei;
          font-weight: bold;
          font-size: 24px;
        }
        .card_btn{
          font-family: SourceHanSansCN-Regular;
          font-size: 17px;
          width: 144px;
          height: 42px;
          border: 1px solid #FFF;
          line-height: 42px;
          margin-top: 33px;
        }
      }
    }
  }
}
</style>